import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper, Alert } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

const SubscriptionCancel: React.FC = () => {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          textAlign: 'center',
        }}
      >
        <Box sx={{ mb: 3 }}>
          <CancelIcon
            sx={{
              fontSize: 80,
              color: 'warning.main',
              mb: 2,
            }}
          />
        </Box>

        <Typography variant="h4" gutterBottom color="warning.main">
          Subscription Cancelled
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
          You cancelled the subscription process. No payment was made.
          You can try again at any time.
        </Typography>

        <Alert severity="info" sx={{ mb: 3 }}>
          To access the application, you'll need to complete the subscription process.
          Don't worry - you can restart it whenever you're ready.
        </Alert>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleGoBack}
          >
            Go Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleTryAgain}
          >
            Try Again
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default SubscriptionCancel;